<template>
  <v-container grid-list-md>
      <v-row dense>
        <v-col v-for="(event, i) in events[city]" :key="i" cols="12">
          <EventCard :event="event" :apihost="apihost" :city="city" @show_event="show_event"/>
        </v-col>
      </v-row>
  </v-container> 
</template>

<script>
var moment = require('moment-timezone');
import EventCard from '@/components/EventCard.vue';

export default {
  name: 'EventList',
  components: {
    EventCard,
  },
  props: ['apihost', 'city', 'lock'],
  data() {
    return {
      events: {
        moscow: [],
        spb: [],
      },
      totalEvents: 0
    }
  },
  methods: {
    show_event(id) {
      this.$emit('show_event', id);
    },
    redraw_events() {
      this.$emit('redraw_events');
    },
    async fetch_events() {
      if (this.events[this.city].length == 0) {
        try {
          let self = this;
          
          const response = await fetch(`${self.apihost}/netatmo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              action: 'fetch',
              source: 'events',
              city: self.city
            })
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          const evts = data;
          
          for (let evt of evts) {
            self.events[self.city].push({
              id: evt.name,
              date: moment(new Date(new Date(evt.date * 8.64e+7 + new Date('1899-12-30').getTime()).setHours(evt.time * 24))),
              title: { en: evt.desc_EN, ru: evt.desc_RU },
              img: `${self.apihost}/uclim/content/${self.city}/Pictures/${evt.name}/index.png`
            });
          }
          
          self.redraw_events();
        } catch (error) {
          console.error('Error fetching events:', error);
        }
      } else {
        this.redraw_events();
      }
    }
  },
  watch: {
    city() {
      this.fetch_events();
    }
  },
  mounted() {   
    this.fetch_events();
  }
}
</script>
